import { FETCH_USERS, NEW_USER, UPDATE_USER } from "../actions/types";

const initialState = {
  item: {}
};

export default function(state = initialState, action) {
  switch (action.type) {
    case FETCH_USERS:
      return {
        ...state,
        items: action.payload
      };
    case UPDATE_USER:
      return {
        ...state,
        items: action.payload.data.data
      };
    case NEW_USER:
      return {
        ...state,
        items: action.payload
      };
    default:
      return state;
  }
}
